import styled from "styled-components";
import { useIntl } from "react-intl";

const EngTitle = styled.div`
  font-family: "Rowdies", cursive;
  margin-right: 8px;
  font-weight: ${(props) => (props.isActive ? "600" : "300")};
  min-width: ${(props) => {
    switch (props.children) {
      case "Home":
        return "60px";
      case "Directory":
        return "90px";
      case "About":
        return "60px";
      case "Submit":
        return "70px";
      default:
        return "auto";
    }
  }};
  text-align: center;
`;

const ChTitle = styled.div`
  font-family: "Noto Sans SC";
  font-weight: ${(props) => (props.isActive ? "900" : "700")};
  position: relative;
  top: -1px;
  min-width: ${(props) => {
    switch (props.children) {
      case "Home":
        return "60px";
      case "Directory":
        return "90px";
      case "About":
        return "60px";
      case "Submit":
        return "70px";
      default:
        return "auto";
    }
  }};
  text-align: center;
`;

const LocaleTitle = ({ children, isActive }) => {
  const intl = useIntl();

  if (intl.locale === "en") {
    return <EngTitle isActive={isActive}>{children}</EngTitle>;
  } else {
    return <ChTitle isActive={isActive}>{children}</ChTitle>;
  }
};

export default LocaleTitle;
